<div class="business-wrap">
  <ng-container *ngIf="titleBarParams | async as params">
    <ad-title-bar *ngIf="!isSnow" [title]="params.title" [subTitle]="params.subTitle"></ad-title-bar>
  </ng-container>
  <div class="container px-lg-10 px-md-10">
    <div class="row px-lg-8 px-md-8">
      <div class="col-12">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
